import React from 'react'

import cn from 'classnames'
import styles from './style.module.css'

interface Props {
    header?: React.ReactNode
    children?: React.ReactNode
    contentWidth?: 'm' | 'l' | 'xl'
    noBorder?: boolean
}

function PageLayout(props: Props) {
    const { contentWidth = 'l', noBorder } = props

    return (
        <div className={cn(styles.wrap, styles[contentWidth])}>
            {props.header && (
                <div className={cn(styles.header, noBorder && styles.noBorder)}>
                    <div className={styles.container}>{props.header}</div>
                </div>
            )}

            <div className={styles.content}>
                <div className={cn(styles.container, styles.mainContent)}>{props.children}</div>
            </div>
        </div>
    )
}

export default PageLayout
